{
  "name": "quotation-tool",
  "version": "3.14.5",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --source-map",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "i18n:sync": "node scripts/i18-sync.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.13",
    "@angular/cdk": "^18.2.14",
    "@angular/common": "^18.2.13",
    "@angular/compiler": "^18.2.13",
    "@angular/core": "^18.2.13",
    "@angular/forms": "^18.2.13",
    "@angular/material": "~18.2.14",
    "@angular/platform-browser": "^18.2.13",
    "@angular/platform-browser-dynamic": "^18.2.13",
    "@angular/router": "^18.2.13",
    "@ngx-translate/core": "^14.0.0",
    "@ngx-translate/http-loader": "^7.0.0",
    "angular-split": "^18.0.0",
    "chart.js": "^4.4.0",
    "date-fns": "^2.29.3",
    "html-to-pdfmake": "^2.5.13",
    "jquery": "^3.7.1",
    "lodash": "^4.17.21",
    "ng2-charts": "^4.1.1",
    "ngx-editor": "15.3",
    "pdfmake": "^0.2.12",
    "rxjs": "~7.8.0",
    "timers": "^0.1.1",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.14",
    "@angular/cli": "~18.2.14",
    "@angular/compiler-cli": "^18.2.13",
    "@types/jasmine": "~4.3.0",
    "@types/lodash": "^4.14.202",
    "@types/node": "^20.9.0",
    "glob": "^11.0.3",
    "jasmine-core": "~4.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "typescript": "~5.4.5"
  },
  "overrides": {
    "prosemirror-model": "1.22.3"
  }
}